import React from 'react'

import {
    Grid,
    MenuItem,
    Typography,
    Box,
    Switch,
    FormControlLabel,
} from "@material-ui/core";
import { SelectValidator, TextValidator } from 'react-material-ui-form-validator';

import { EMITIDO_POR_LIST } from '../../data/constants';
import { DiagnosticosForm } from '../../components/DiagnosticosForm';
import { limiteInput } from '../../../../helpers/limiteInput';

export const FormDatosCud = ({ formValues, handleInputChange, setearValor, classes }) => {

    return (
        <>
            <Grid item xs={12} >
                <SelectValidator
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    label="Emitido Por"
                    name="idEntidadEmision"
                    value={formValues.idEntidadEmision}
                    onChange={handleInputChange}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                    validators={["required"]}
                    errorMessages={["Este campo es obligatorio"]}
                    style={{ color: '#000' }}
                >
                    <MenuItem value={""}><em>Seleccione</em></MenuItem>
                    {EMITIDO_POR_LIST.map((e) => (
                        <MenuItem key={e.id} value={e.id} >{e.descripcion}</MenuItem>
                    ))}
                </SelectValidator>
            </Grid>
            <Grid item xs={12}>
                <DiagnosticosForm
                    formValues={formValues}
                    setearValor={setearValor}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextValidator
                    multiline
                    fullWidth
                    rows={3}
                    variant="outlined"
                    margin="normal"
                    label="Prestaciones Cubiertas"
                    name="prestacionesCubiertas"
                    value={formValues.prestacionesCubiertas}
                    onChange={e => {
                        limiteInput({
                            e, handleInputChange, setearValor,
                            limit: 1000,
                            value: formValues.prestacionesCubiertas,
                            name: "prestacionesCubiertas"
                        })
                    }}
                    inputProps={{ maxLength: 1000 }}
                    validators={["required"]}
                    errorMessages={["Este campo es obligatorio"]}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextValidator
                    multiline
                    fullWidth
                    rows={3}
                    variant="outlined"
                    margin="normal"
                    label="Observaciones"
                    name="observaciones"
                    value={formValues.observaciones}
                    onChange={handleInputChange}
                    validators={["required"]}
                    inputProps={{ maxLength: 500 }}
                    errorMessages={["Este campo es obligatorio"]}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextValidator
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    label="Nombre Padre / Madre / Tutor"
                    name="nombrePadreMadreTutor"
                    value={formValues.nombrePadreMadreTutor}
                    onChange={handleInputChange}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextValidator
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    label="Email"
                    name="email"
                    value={formValues.email}
                    onChange={handleInputChange}
                    validators={["isEmail"]}
                    errorMessages={["Email invalido"]}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextValidator
                    fullWidth
                    variant="outlined"
                    margin="normal"
                    label="Celular"
                    name="celular"
                    value={formValues.celular}
                    onChange={handleInputChange}
                    InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <Box display='flex' justifyContent='center' alignItems='center'>
                    <Typography variant="button">Acompañante</Typography>
                    <FormControlLabel style={{ marginLeft: 5 }} control={
                        <Switch
                            name="acompanante"
                            onChange={(e) => { setearValor("acompanante", e.target.checked) }}
                            checked={formValues.acompanante}
                            color="primary"
                            classes={{ switchBase: classes.switchBase, checked: classes.checked, track: classes.track }}
                        />}
                    />
                </Box>
            </Grid>
        </>
    )
}
